export function isEmpty(obj): boolean {
    return Object.keys(obj).length === 0
}

export function buildScenario(data) {
    const { threats, consequences, staggering, barries, bowtie, scenarios } = data

    if (Object.keys(data).length) {
        staggering.map(sta => sta.children.map((c, i) => (sta.children[i] = barries.filter(b => c === b.id)[0])))
        barries.map(bar => {
            bar.children &&
                bar.children.map((b, i) => {
                    bar.children[i] = staggering.filter(d => {
                        if (b === d.id) {
                            return d
                        }
                    })[0]
                })
        })
        threats.map(thr => thr.children.map((c, i) => (thr.children[i] = barries.filter(b => c === b.id)[0])))
        consequences.map(cnq => cnq.children.map((c, i) => (cnq.children[i] = barries.filter(b => c === b.id)[0])))
        bowtie.map(bwt => {
            bwt.threats.map((d, i) => (bwt.threats[i] = threats.filter(r => d === r.id)[0]))
            bwt.consequences.map((d, i) => (bwt.consequences[i] = consequences.filter(r => d === r.id)[0]))
        })
        Object.keys(scenarios).map(key => {
            const newValues = {}

            scenarios[key].map(val => {
                const obj = bowtie.filter(b => b.id === val)[0]

                Object.assign(newValues, { [obj.id]: obj })
            })
            scenarios[key] = newValues
        })
    }

    return scenarios
}

type Mode = 'desktop' | 'tablet' | 'phone'

export const changeDashboard = (dashboardContext: LiveDashboardContextValue, mode: Mode): void => {
    const dashboardCFG = { ...dashboardContext }
    const shallowCFG: LiveDashboardContextValue = { ...dashboardCFG }
    const { actions, dashboard } = shallowCFG

    dashboard.jsonConfig.layoutModes[mode].gridRowHeight = 'static'

    const {
        jsonConfig: { layoutModes }
    } = dashboard

    actions.updateUserLayout(layoutModes[mode])
}

export const addStyleContainerWidget = (id: string | number): boolean => {
    const container = document.querySelector(`.react-grid-item .widget-${id}`)

    if (container) {
        container.classList.add('widget-mobile-bowtie-style')

        return true
    }

    return false
}
const stylesheet = `
    .widget-mobile-bowtie-style {
        padding: 0! important;
        background: #DDDEE1 !important;
        border-radius: 4px !important;
    }
    .widget-content,
    .mobileBowtie-widget,
    .widget-content.mobileBowtie-widget {
        padding: 0! important;
    }
    .layout-alert {
        display: none;
    }       
`

const bowtieStyle = document.createElement('style')
bowtieStyle.setAttribute('mobile-bowtie-style', 'true')
bowtieStyle.innerHTML = stylesheet

export const hasTagStyle = (): Element => document.querySelector('style[mobile-bowtie-style="true"]')
export { bowtieStyle }

// const pxToGridY = (y: number): number => (y + (y / 100)) / (y / 10) + 1
// const pxToGridY = (y: number): number => (y * 10) / 100 - 2.6
const pxToGridY = (y: number): number => (y + 10) / 20
export const resizeY = (
    dashboardContext: LiveDashboardContextValue,
    mode: Mode,
    id: string | number,
    y: number,
    oldY = false
): void => {
    const dashboardCFG = { ...dashboardContext }
    const shallowCFG: LiveDashboardContextValue = { ...dashboardCFG }
    const { actions, dashboard } = shallowCFG

    dashboard.jsonConfig.layoutModes[mode].grid[String(id)].size_y = oldY ? y : pxToGridY(y)
    dashboard.jsonConfig.layoutModes[mode].gridRowHeight = 'static'

    const {
        jsonConfig: { layoutModes }
    } = dashboard

    actions.updateUserLayout(layoutModes[mode])
}

export const options = {
    toleravel: {
        label: 'Tolerable',
        icon: 'exclamation',
        color: '#F89300'
    },
    'amplamente aceitavel': {
        label: 'Widely Acceptable',
        icon: 'check',
        color: '#01C292'
    },
    intoleravel: {
        label: 'Intolerable',
        icon: 'times',
        color: '#C43535'
    }
}

export const dataArray = [
    { id: 'MAH-16', status: 'tolerable', prevention: 2, totalPrevention: 6, mitigation: 0, totalMitigation: 6 },
    { id: 'MAH-17', status: 'acceptable', prevention: 0, totalPrevention: 5, mitigation: 0, totalMitigation: 5 },
    { id: 'MAH-04', status: 'intolerable', prevention: 5, totalPrevention: 5, mitigation: 2, totalMitigation: 5 }
]
